<template>
    <div style="width: 100%" class="public">
        <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;font-size: 13px">
            <div style="margin: auto 0;color: #595a5a;padding-left: 20px"><span >当前位置：</span></div>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: auto 0;font-size: 13px">
                <el-breadcrumb-item v-for="(item,index) in $route.meta.position" :key="index">
                    {{item}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="text-align: right;">
            <el-row style="background-color: #EEEEEE;">
                <el-col :span="24">
                    <el-button type="info" size="small" @click="returnPage">返回</el-button>
                    <el-button type="warning" size="small" @click="batchUpdataGoods">保存</el-button>
                </el-col>
            </el-row>
        </div>
        <el-form  ref="form" :rules="rules"  :model="form" label-width="80px"
                  >
            <!-- 基本信息 -->
            <div style="background-color: #FFFFFF;margin-top: 15px;width: 100%">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>基本信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <!-- 主内容 -->
                    <el-main>
                            <el-form-item label="商品SPU" >
                                <el-input v-model="form.commSpu" :disabled="true" style="width: 200px;" size="small"></el-input>
                            </el-form-item>
                            <!--商品分类-->
                            <el-form-item label="商品分类" prop="typeId">
                                <TreeSelect :props="treeSelect" :options="dataList"  v-model="form.typeId" ref="childSelTree"
                                            style="width: 30%;margin-right: 10px" @getValue="getTreeNodeId"></TreeSelect>
                            </el-form-item>
                    </el-main>
                </el-container>
            </div>
            <!--SKU信息-->
            <div style="background-color: #FFFFFF;margin-top: 15px;width: 100%">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>SKU信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <!-- 主内容 -->
                    <el-main style="width: 100%">
                       <el-row>
                           <span>生成变种</span>
                       </el-row>
                        <el-row v-for="(item,index) in form.attributList" style="margin-top: 10px">
                            <el-col :span="1" style="text-align: right">
                                <i class="el-icon-remove-outline" style="font-size: 20px;margin-right: 10px;color: #8071c9;cursor: pointer" @click="deleteAttrName(index)"></i>
                            </el-col>
                            <el-col :span="5" style="text-align: right">
                                <el-input
                                        @blur="handleName(index)"
                                        v-model.trim="item.attributeName"
                                        size="mini" placeholder="属性名,如:Color"
                                        style="width: 200px;margin-right: 15px"
                                        onkeyup="this.value=this.value.replace(/(^\s*)|(\s*$)/g, '')"></el-input>
                            </el-col>
                            <el-col :span="8">
                                <!--标签-->
                                <el-tag
                                        :key="tag"
                                        v-for="tag in item.dynamicTags"
                                        closable
                                        :disable-transitions="false"
                                        @close="handleClose(tag,index)">
                                    {{tag}}
                                </el-tag>
                                <el-input
                                        class="input-new-tag"
                                        v-if="item.inputVisible"
                                        v-model.trim="item.attributeValue"
                                        ref="saveTagInput"
                                        size="small"
                                        @keyup.enter.native="handleInputConfirm(index)"
                                        @blur="handleInputConfirm(index)"
                                        onkeyup="this.value=this.value.replace(/[\s]/g, '');"
                                >
                                </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput(index)">+添加新属性值</el-button>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top: 10px">
                            <span>
                                 <el-link type="primary" @click="addAttribute">+添加新属性</el-link>
                            </span>
                        </el-row>
                        <el-row style="margin-top: 10px">
                            <span>
                                编辑变种
                            </span>
                        </el-row>
                        <div style="margin-top: 10px">
                            <el-table id="table" ref="multipleTable" :data="form.tableData"
                                      style="width: 100%" @selection-change="handleSelectionChange">
                                <!--<el-table-column type="selection" width="40" align="center"></el-table-column>-->
                                <el-table-column prop="picUrl" label="图片"  align="center">
                                    <template slot-scope="scope">
                                        <!--http-request如果想处理额外参数,则在方法里面再调用方法-->
                                        <el-upload
                                                :show-file-list="false"
                                                class="upload-demo"
                                                action="#"
                                                multiple
                                                :http-request="function (res) { return handleParam(res, scope.$index)}">
                                            <div v-show="scope.row.picUrl==''">
                                                <i class="el-icon-plus" style="font-size: 25px"></i>
                                            </div>
                                            <img v-show="scope.row.picUrl!=''" style="width: 80px" :src="scope.row.picUrl" />
                                        </el-upload>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="varAttr" label="变种信息" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item label-width="10px" >
                                            <span>{{scope.row.varAttr}}</span>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="" label="商品SKU"  align="center">
                                    <template slot-scope="scope">
                                        <el-form-item label-width="10px" :prop="'tableData.'+scope.$index+'.commSku'"   :rules='rules.commSku'>
                                            <el-input size="mini" v-model.trim="scope.row.commSku" placeholder="请输入内容"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="" label="中文名称"  align="center" >
                                    <template slot-scope="scope">
                                        <el-form-item label-width="10px"  :prop="'tableData.'+scope.$index+'.chinName'"   :rules='rules.chinName'>
                                            <el-input size="mini" v-model.trim="scope.row.chinName" placeholder="请输入内容"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="" label="英文名称"  align="center">
                                    <template slot-scope="scope">
                                        <el-form-item label-width="10px" :prop="'tableData.'+scope.$index+'.engName'"   :rules='rules.engName' >
                                            <el-input size="mini" v-model.trim="scope.row.engName" placeholder="请输入内容"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="" label="来源URL"  align="center">
                                    <template slot-scope="scope">
                                        <el-form-item label-width="10px" :prop="'tableData.'+scope.$index+'.url'"   :rules='rules.url'>
                                            <el-input size="mini" v-model.trim="scope.row.url" placeholder="请输入内容"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="" label="识别码"  align="center">
                                    <template slot-scope="scope">
                                        <el-form-item label-width="10px"  :prop="'tableData.'+scope.$index+'.recoNo'"   :rules='rules.recoNo'>
                                            <el-input size="mini" v-model.trim="scope.row.recoNo" placeholder="请输入内容"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="" label="操作"  align="center">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="appAllTableData(scope.row)">应用所有</el-link><br>
                                        <el-link type="primary" @click="deleteAttr(scope.row,scope.$index)">移除</el-link>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>

                    </el-main>
                </el-container>
            </div>
            <!-- 人员信息 -->
            <div style="background-color: #FFFFFF;margin-top: 15px;width: 100%">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>人员信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <!-- 主内容 -->
                    <el-main>
                        <el-form-item label="开发人员" prop="code">
                            <el-select clearable  v-model="form.empNo" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in shopAllUserOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!--商品分类-->
                        <el-form-item label="采购员">
                            <el-select clearable  v-model="form.proEmpNo" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in shopAllUserOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-main>
                </el-container>
            </div>
            <!-- 仓库信息 -->
            <div style="background-color: #FFFFFF;margin-top: 15px;width: 100%">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>仓库信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <!-- 主内容 -->
                    <el-main>
                        <el-form-item>
                            <el-radio-group v-model="form.wareId">
                                <el-radio
                                        v-for="item in wareList"
                                        :label="item.value"
                                >{{item.label}}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-main>
                </el-container>
            </div>
            <!-- 重量信息 -->
            <div style="background-color: #FFFFFF;margin-top: 15px;width: 100%">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>人员信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <!-- 主内容 -->
                    <el-main>
                        <el-form-item label="商品重量" prop="weight">
                            <el-input
                                    size="mini"
                                    v-model.trim="form.weight"
                                    placeholder="仅支持数字"
                                    style="width: 200px;margin-right: 10px"
                                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"></el-input>(g)
                        </el-form-item>
                        <el-form-item label="商品尺寸">
                            <el-row>
                                <el-col :span="3">
                                    <el-input v-model.trim="form.commLong"  placeholder="长" size="mini" onkeyup="this.value=this.value.replace(/[^\d]/g, '')"></el-input>
                                </el-col>
                                <el-col :span="3" style="margin-left: 8px">
                                    <el-input v-model.trim="form.commWide"  placeholder="宽" size="mini" onkeyup="this.value=this.value.replace(/[^\d]/g, '')"></el-input>
                                </el-col>
                                <el-col :span="3" style="margin-left: 8px;margin-right: 10px">
                                    <el-input v-model.trim="form.commHigh"  placeholder="高" size="mini" onkeyup="this.value=this.value.replace(/[^\d]/g, '')"></el-input>
                                </el-col>
                                (CM)
                            </el-row>
                            <!--<el-input  placeholder="长"></el-input>-->
                            <!--<el-input  placeholder="宽"></el-input>-->
                            <!--<el-input  placeholder="高"></el-input>-->
                        </el-form-item>
                    </el-main>
                </el-container>
            </div>
        </el-form>

        <!-- 回到顶部 -->
        <el-backtop></el-backtop>


    </div>
</template>

<script>
    import ElRow from "element-ui/packages/row/src/row";
    import {selectWareListRadio,save,getManyGoods,getAttrListByCommId,getGoodsListByCommPId,batchUpdataGoods} from '@/api/store/storeManage';
    import {goodsUploadImg,getAllShopUser,getUserId} from '@/api/product/common';
    import TreeSelect from '@/components/common/treeSelect';
    import {calcDescartes} from '@/utils/jn';
    import {loadDataMap} from '@/api/store/commType'

    const  cityOptions = ['默认仓库', '仓库1', '仓库2', '仓库3'];
    export default {
        components: {
            ElRow,
            TreeSelect
        },
        data: function() {
            return {
                form: {
                    tableData:[],
                    commSpu: null,
                    //添加新的属性集合
                    attributList: [
                        // {
                        //     attributeName:null,
                        //     attributeValue:null,
                        //     dynamicTags: ['标签一', '标签二', '标签三'],
                        //     inputVisible: false,
                        // },
                        // {
                        //     attributeName:null,
                        //     attributeValue:null,
                        //     dynamicTags: ['标签一', '标签二', '标签三'],
                        //     inputVisible: false,
                        // }
                    ],
                    typeId: null, //商品分类
                    empNo: null, //开发员
                    proEmpNo: null,//采购员
                    wareId: null, //仓库
                    weight: null, //商品净重
                    commLong: null, //长
                    commWide: null,//宽
                    commHigh: null, //高
                },
                picIndex: 0,//表格内图片的索引
                //树形数据
                dataList: [],
                //下拉树
                treeSelect: {
                    value: 'id',
                    label: 'name',
                    children: 'children',
                    pCatId: 'pCatId',
                },
                wareList: [],//仓库列表
                shopAllUserOptions: [],//用户列表
                rules: {
                    chinName: [
                        { required: true, message: '请输入中文名称', trigger: 'blur'},
                    ],
                    engName: [
                        { required: true, message: '请输入英文名称', trigger: 'blur' },
                    ],
                    url: [
                        { required: true, message: '请输入URL', trigger: 'blur' },
                    ],
                    recoNo: [
                        { required: true, message: '请输入识别码', trigger: 'blur' },
                    ],
                    weight: [
                        { required: true, message: '请输入商品净重', trigger: 'blur' },
                    ],
                    typeId: [
                        { required: true, message: '请选择商品分类', trigger: 'blur' },
                    ],
                    commSku: [
                        { required: true, message: '请输入商品SKU', trigger: 'blur' },
                    ],
                },

            }


        },
        methods:{
            handleClose(tag,index) {
                this.form.attributList[index].dynamicTags.splice(this.form.attributList[index].dynamicTags.indexOf(tag), 1);
                this.loadSku();
            },

            showInput(index) {
                this.$set(this.form.attributList[index], 'inputVisible', true)
                // this.inputVisible = true;
                this.$nextTick(_ => {
                    let saveTagInput = this.$refs.saveTagInput[0];
                    this.$refs.saveTagInput[0].focus();
                });
            },

            handleInputConfirm(index) {
                var attributeName = this.form.attributList[index].attributeName;
                if (attributeName==null || attributeName.replace(/[\s]/g, '')==''){
                    this.msgError("属性名不能为空");
                    this.inputHide(index);
                    return
                }
                //获取input的值
                var inputValue = this.form.attributList[index].attributeValue;
                if (inputValue==null || inputValue.replace(/[\s]/g, '')==''){
                    this.inputHide(index);
                    return
                }
                //获取标签集合
                var dynamicTags = this.form.attributList[index].dynamicTags;
                //是否包含这个值
                let b = dynamicTags.includes(inputValue);
                if (b && inputValue){
                    this.msgError(inputValue+"已存在");
                    this.inputHide(index);
                    return
                }
                if (inputValue) {
                    this.form.attributList[index].dynamicTags.push(inputValue)
                }
                this.loadSku();
                this.inputHide(index);
            },
            addAttribute(){
                for (var i=0 ; i<this.form.attributList.length;i++){
                    if (this.form.attributList[i].attributeName==null || this.form.attributList[i].attributeName==' '){
                        this.msgError("请先填写新增的属性,再添加下一个");
                        return
                    }
                    if (this.form.attributList[i].dynamicTags.length <=0){
                        this.msgError("请先填写属性值,再添加下一个");
                        return
                    }
                }
                this.form.attributList.push(
                    {
                        attributeName:null,
                        attributeValue:null,
                        dynamicTags: [],
                        inputVisible: false,
                        inputValue: '',
                    }
                )
            },
            //表格checkbox选择
            handleSelectionChange(){

            },
            //往表格添加一条数据
            addTable(name,value){
                this.form.tableData.push(
                    {
                        varAttr:name,
                        picUrl:'',
                        commSku:value,
                        chinName:'',
                        engName:'',
                        url:'',
                        recoNo:'',
                    }
                )
            },
            //隐藏输入框并把值=''
            inputHide(index){
                this.$set(this.form.attributList[index], 'inputVisible', false)
                this.$set(this.form.attributList[index], 'attributeValue', '')
            },
            //动态增删SKU
            loadSku(){
                this.form.tableData=[];
                var attributList = this.form.attributList;
                //如果有多个则遍历添加
                var cartesianArray=[];
                for (var i=0; i<attributList.length; i++){
                    //获取标签的集合
                    var dynamicTags2 = this.form.attributList[i].dynamicTags;
                    cartesianArray.push(dynamicTags2);
                }
                var calcDescartes2 = calcDescartes(cartesianArray);
                //变种信息
                var attributeName='';
                // 商品SKU
                var value ="";
                for (var i=0; i<calcDescartes2.length; i++){
                    //判断是不是数组
                    if (calcDescartes2[i].constructor==Array){
                        value = calcDescartes2[i].join("-");
                        attributeName = calcDescartes2[i].join("*");
                    }else {
                        value = calcDescartes2[i];
                        attributeName = calcDescartes2[i];
                    }
                    this.addTable(attributeName,value);
                }
            },
            //覆盖默认上传行为
            handleParam(data,index){
                this.uploadByPicType(data,index)
            },
            //上传图片时,区分不同的图片类型参数
            uploadByPicType(data,index){
                var formData = new FormData();
                //文件
                formData.append("imageFile", data.file);
                goodsUploadImg(formData).then(res => {
                    if(res.code == 200){
                        this.$set(this.form.tableData[index], 'picUrl', res.data.img);
                        for (var i=0; i<this.form.tableData.length; i++){
                            if(this.form.tableData[i].picUrl=='' || this.form.tableData[i].picUrl==null){
                                this.$set(this.form.tableData[i], 'picUrl', res.data.img);
                            }
                        }
                        this.msgSuccess(res.msg);
                    }
                }).catch(err => {});
            },
            //清空属性名时提示的操作
            handleName(index){
                var attributeName = this.form.attributList[index].attributeName;
                var dynamicTags = this.form.attributList[index].dynamicTags
                if(attributeName==null || attributeName==""){
                    if (dynamicTags.length > 0){
                        this.$confirm('清空属性值会清空所有的属性名,你确定要清空吗', "警告", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        }).then(function() {
                            return true;
                        }).then(() => {
                            this.$set(this.form.attributList[index], 'dynamicTags', []);
                            this.loadSku();
                            this.msgSuccess("清空成功");
                        }).catch(function() {});
                    }

                }

            },
            //树形赋值
            getTreeNodeId(val) {
                this.form.typeId = val;
            },
            getTree(that){
                // 获取本平台树
                loadDataMap().then((res) => {
                    that.dataList=that.optionData(res.data);
                    setTimeout(function () {
                        that.$refs.childSelTree.initHandle();
                    },100);
                })
            },
            //处理tree的数据
            optionData(data) {
                let cloneData = JSON.parse(JSON.stringify(data))      // 对源数据深度克隆
                return cloneData.filter(father => {                      // 循环所有项，并添加children属性
                    let branchArr = cloneData.filter(child => father.id == child.parentId);       // 返回每一项的子级数组
                    branchArr.length > 0 ? father.children = branchArr : ''   //给父级添加一个children属性，并赋值
                    return father.parentId == 0;      //返回第一层
                });
            },
            //获取店铺下的所有用户
            getAllShopUser(){
                getAllShopUser().then((res) => {
                    this.shopAllUserOptions =res.data;
                })
            },
            //获取用户ID
            getUserId(){
                getUserId().then((res) => {
                    this.form.empNo=res.data
                    this.form.proEmpNo=res.data
                })
            },
            //获取用户下的所有仓库
            selectWareListRadio(){
                selectWareListRadio().then((res) => {
                    this.wareList=res.data
                })
            },
            //移除属性
            deleteAttr(row,index){
                //删除表格的一条数据
                this.form.tableData.splice(index,1);
                //获取sku
                let commSku = row.commSku;
                //分割数组
                var commSkuList = commSku.split("-");
                //遍历数组
                for (var i=0; i<commSkuList.length; i++){
                    //取出对应的属性值
                    var commSku2 = commSkuList[i];
                    //定义好是否需要删除属性值的标志
                    var flag=false;
                    for (var j=0; j<this.form.tableData.length; j++){
                        //取出SKU
                        var commSku3 = this.form.tableData[j].commSku;
                        //分割成数组
                        var split = commSku3.split("-");
                        //取出i对应的索引
                        let split2 = split[i];
                        if (split2==commSku2){
                            flag=true;
                        }
                    }
                    if (!flag){
                        //获取对应的属性名
                        let attributList = this.form.attributList[i];
                        //取出属性值集合
                        let dynamicTags = attributList.dynamicTags;
                        //遍历属性值,如果有对应的则删除掉,因为表格里已经没有数据了
                        for (var i2=0; i2<dynamicTags.length; i2++){
                            if (commSku2==attributList.dynamicTags[i2]){
                                this.form.attributList[i].dynamicTags.splice(i2,1);
                            }
                        }
                    }
                }
            },
            returnPage(){
                this.$router.push({path:"/repository/manage/goodsManage",query:{}})
            },
            //获取商品的基本属性
            getManyGoods(){
                getManyGoods(this.$route.query.commId).then((res) => {
                    var data = res.data;
                    this.form.commSpu=data.commSpu;
                    this.form.typeId=parseInt(data.typeId);
                    this.form.wareId=data.wareId;
                    this.form.weight=data.weight;
                    this.form.commLong=data.commLong;
                    this.form.commWide=data.commWide;
                    this.form.commHigh=data.commHigh;
                    //处理下拉框数据,防止显示错误
                    if (data.empNo!='' && data.empNo!=null){
                        this.form.empNo=parseInt(data.empNo)
                    }
                    if (data.proEmpNo!='' && data.proEmpNo!=null){
                        this.form.proEmpNo=parseInt(data.proEmpNo)
                    }
                })
            },
            //获取属性集合
            getAttrListByCommId(){
                getAttrListByCommId(this.$route.query.commId).then((res) => {
                    this.form.attributList=res.data;
                })
            },
            //根据commPId获取子商品集合
            getGoodsListByCommPId(){
                getGoodsListByCommPId(this.$route.query.commId).then((res) => {
                    this.form.tableData = res.data;
                })
            },
            //删除属性名
            deleteAttrName(index){
                this.form.attributList.splice(index,1);
                this.loadSku();
            },
            //批量修改
            batchUpdataGoods(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        var data = this.form;
                        data['commId']=this.$route.query.commId;
                        data['commType']='02';
                        //必须要有一个sku
                        var attributList = this.form.attributList;
                        if (attributList.length <=0){
                            this.msgError("至少添加一个SKU");
                            return;
                        }
                        batchUpdataGoods(data).then((res) => {
                            this.msgSuccess("保存成功");
                        })
                    } else {
                        this.msgError("请输入必填信息");
                        return false;
                    }
                });
            },
            //应用所有
            appAllTableData(row){
                var chinName = row.chinName;
                var engName = row.engName;
                var url = row.url;
                for (var i=0; i<this.form.tableData.length; i++){
                    this.form.tableData[i].chinName = chinName;
                    this.form.tableData[i].engName = engName;
                    this.form.tableData[i].url = url;
                }
            },

        },
        //进来就调用
        created() {
            var that = this;
            that.getGoodsListByCommPId();
            that.getTree(that);
            that.getUserId();
            that.getAllShopUser();
            that.selectWareListRadio();
            that.getManyGoods();
            that.getAttrListByCommId();

        }
    }
</script>

<style>

</style>
